/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Space_WideInputs */

const en_space_wide = /** @type {(inputs: Space_WideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Space-wide`)
};

const de_space_wide = /** @type {(inputs: Space_WideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bereichsweit`)
};

/**
* | output |
* | --- |
* | "Space-wide" |
*
* @param {Space_WideInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const space_wide = /** @type {((inputs?: Space_WideInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Space_WideInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_space_wide(inputs)
	return en_space_wide(inputs)
});